import React from 'react';
import { Route, Switch, withRouter } from 'react-router';

import VehicleList from './list/VehicleList';
import DriverOnboardingNew from './new/DriverOnboardingNew';
import VehicleEdit from './edit/VehicleEdit';

class Vehicles extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/app/vehicles" exact component={VehicleList} />
        <Route path="/app/vehicles/new" exact component={DriverOnboardingNew} />
        <Route path="/app/vehicles/:id/edit" exact component={VehicleEdit} />
      </Switch>
    );
  }
}

export default withRouter(Vehicles);
